export default __webpack_public_path__ + "static/media/bb_guess_6.32b3b3c8.png";